import { render, staticRenderFns } from "./WeverseSimul.vue?vue&type=template&id=39d64d5e&scoped=true&"
import script from "./WeverseSimul.vue?vue&type=script&lang=js&"
export * from "./WeverseSimul.vue?vue&type=script&lang=js&"
import style0 from "./WeverseSimul.vue?vue&type=style&index=0&id=39d64d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d64d5e",
  null
  
)

export default component.exports